import * as storage from './storage'
//import * as api from './api'
import * as utils from './utils'
import * as mask from './mask'
import * as validate from './validateForm'
import * as validaCpf from './validaCpf'
import * as validaCnpj from './validaCnpj'
import * as validaCpfCnpj from './validaCpfCnpj'

export default {
    storage,
    utils,
    mask,
    validate,
    validaCpf,
    validaCnpj,
    validaCpfCnpj
}